import { useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import AttachmentPicker from "../feedback/AttachmentPicker";
import { api, formatApiError } from "../../lib/api";
import { SUPPORT_CATEGORY, SUPPORT_PRIORITY } from "../../lib/supportLabels";

export default function TicketForm({ companyId, onClose, onDone }) {
  const [f, setF] = useState({ subject: "", description: "", category: "technique", priority: "normal" });
  const [files, setFiles] = useState([]);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async () => {
    if (f.subject.trim().length < 5 || f.description.trim().length < 10) { toast.error("Objet (5 caractères min.) et description (10 min.) requis"); return; }
    setBusy(true);
    const fd = new FormData();
    fd.append("payload", JSON.stringify({ ...f, company_id: companyId || null }));
    files.forEach((x) => fd.append("files", x));
    try { const { data } = await api.post("/support/tickets", fd); toast.success(`Ticket ${data.number} ouvert`); onDone(data); }
    catch (e) { toast.error(formatApiError(e)); }
    setBusy(false);
  };
  return (
    <Dialog open onOpenChange={(o) => { if (!o) { onClose(); } }}>
      <DialogContent className="max-w-xl" data-testid="ticket-form-dialog">
        <DialogHeader><DialogTitle>Nouvelle demande de support</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div><Label>Objet</Label><Input maxLength={150} value={f.subject} onChange={set("subject")} data-testid="ticket-subject-input" /></div>
          <div className="grid gap-3 sm:grid-cols-2">
            <div><Label>Catégorie</Label><select className="field-select" value={f.category} onChange={set("category")} data-testid="ticket-category-select">{Object.entries(SUPPORT_CATEGORY).map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select></div>
            <div><Label>Priorité</Label><select className="field-select" value={f.priority} onChange={set("priority")} data-testid="ticket-priority-select">{Object.entries(SUPPORT_PRIORITY).map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select></div>
          </div>
          <div><Label>Description</Label><Textarea rows={5} maxLength={5000} value={f.description} onChange={set("description")} data-testid="ticket-description-input" /></div>
          <div><Label className="mb-1.5 block">Pièces jointes (facultatif)</Label><AttachmentPicker files={files} onChange={setFiles} /></div>
        </div>
        <DialogFooter><Button variant="outline" onClick={onClose} data-testid="ticket-form-cancel">Annuler</Button>
          <Button onClick={submit} disabled={busy} data-testid="ticket-form-submit">{busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}Envoyer</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
